import PageLayout from "@/components/layout/PageLayout";
import QuoteForm from "@/components/sections/QuoteForm";
import Cities from "@/components/sections/Cities";
import PageBreadcrumb from "@/components/layout/PageBreadcrumb";

const QuotePage = () => {
  return (
    <PageLayout>
      <PageBreadcrumb currentPage="Get a Quote" />
      <QuoteForm />
      <Cities />
    </PageLayout>
  );
};

export default QuotePage;